export const StripeConnectInfoCollection = "stripe-connections";

export function mapDocToStripeConnectInfo(data: any): StripeConnectInfo {
  return {
    projectId: data.projectId,
    projectOwnerUserId: data.projectOwnerUserId,
    // Stripe Connect
    accessToken: data.accessToken,
    refreshToken: data.refreshToken,
    stripeUserId: data.stripeUserId,
    stripePublishableKey: data.stripePublishableKey,
    // Sync metadata
    lastSyncedAt: data.lastSyncedAt ?? null,
    lastSyncedChargeId: data.lastSyncedChargeId ?? null,
    lastSyncedChargeDate: data.lastSyncedChargeDate ?? null,
    syncRangeStart: data.syncRangeStart ?? null,
    syncRangeEnd: data.syncRangeEnd ?? null,
    totalChargesSynced: data.totalChargesSynced ?? 0,
  };
}

export interface StripeConnectInfo {
  projectId: string;
  projectOwnerUserId: string;
  accessToken: string;
  refreshToken: string;
  stripeUserId: string;
  stripePublishableKey: string;
  // Sync metadata
  lastSyncedAt: number | null;
  lastSyncedChargeId: string | null;
  lastSyncedChargeDate: number | null;
  syncRangeStart: number | null;
  syncRangeEnd: number | null;
  totalChargesSynced: number;
}
